import styled from '@emotion/styled'
import { stylesIf } from 'utils/styles'

export const StyledNavSticky = styled.div((props) => {
  // shadow if stuck bug ignore if adjacent to sticky page meta
  const shadow = stylesIf(
    props.stuck,
    `
        box-shadow: 
        0 1px 1px -1px rgba(0,0,0,0.1), 
        0 1px 4px 0 rgba(0,0,0,0.08), 
        0 4px 5px 0 rgba(0,0,0,0.12);
        
      `
  )
  return `
      position: sticky;
      top: 0;
      z-index: 20;
      
      ${shadow}
    `
})
